// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"da7daefb","131":"a570e3e8"}[chunkId] + ".chunk.css";
};